<template>
  <div class="Drops-filters ml-0">
    <WrldTextFieldRefFilter
      :wrld="{index: 'Organizations', facetIndex: 'OrganizationsFacets', referenceIndex: 'OrganizationsReference', pageSize: 20}"
    />
    <WrldTextFieldFilters :wrld="{index: 'Organizations', facetIndex: 'OrganizationsFacets', pageSize: 20}" />
    <WrldCurrentFiltersV2
    :wrld="{index: 'Organizations', facetIndex: 'OrganizationsFacets', pageSize: 20, isResource: true}"
    :translatedFilters="[
      {
        type: 'Verified',
        i18nPreffix: 'organizations'
      }
    ]"
    />
    <WrldSelectableFiltersV2
    :wrld="{index: 'Organizations', facetIndex: 'OrganizationsFacets', pageSize: 20}"
    :arrFilters="WrldSelectablearrFilters"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import WrldCurrentFiltersV2 from '@/components/wrld/filters/WrldCurrentFiltersV2'
import WrldSelectableFiltersV2 from '@/components/wrld/filters/WrldSelectableFiltersV2'
import WrldTextFieldFilters from '@/components/wrld/filters/WrldTextFieldFilters'
import WrldTextFieldRefFilter from '@/components/wrld/filters/WrldTextFieldRefFilter'

export default {
  name: 'OrganizationsFilters',
  components: {
    WrldSelectableFiltersV2,
    WrldTextFieldFilters,
    WrldCurrentFiltersV2,
    WrldTextFieldRefFilter
  },
  mounted() {
    if (this.getResourceIndex !== 'Organizations') {
      this.setResourceIndex({ index: 'Organizations' })
    }
  },
  data () {
    return {
      translatedFilters: ['false', 'true']
    }
  },
  methods: {
    ...mapActions({
      setResourceIndex: 'setResourceIndex'
    })
  },
  computed: {
    ...mapGetters([
      'getResourceIndex'
    ]),
    arrFilters () {
      return [
        { title: this.$t('companies.reference_number'), attribute: 'refNumber' },
        { title: this.$t('companies.company_name'), attribute: 'name' },
        { title: this.$t('locations.address'), attribute: 'location' },
        { title: this.$t('companies.groups'), attribute: 'groups' },
        { title: this.$t('companies.labels'), attribute: 'labels' }
      ]
    },
    WrldSelectablearrFilters () {
      return [
        { title: this.$t('locations.address'), attribute: 'Address' },
        { title: this.$t('companies.labels'), attribute: 'Labels' },
        { title: this.$t('locations.verified'), attribute: 'Verified', isSearchable: false,  i18nPreffix: 'locations.' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
